/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExamDateDto
 */
export interface ExamDateDto {
    /**
     * 
     * @type {Date}
     * @memberof ExamDateDto
     */
    startDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDateDto
     */
    startVersion?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExamDateDto
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExamDateDto
     */
    endVersion?: string | null;
}

/**
 * Check if a given object implements the ExamDateDto interface.
 */
export function instanceOfExamDateDto(value: object): value is ExamDateDto {
    return true;
}

export function ExamDateDtoFromJSON(json: any): ExamDateDto {
    return ExamDateDtoFromJSONTyped(json, false);
}

export function ExamDateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamDateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'startVersion': json['startVersion'] == null ? undefined : json['startVersion'],
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'endVersion': json['endVersion'] == null ? undefined : json['endVersion'],
    };
}

export function ExamDateDtoToJSON(value?: ExamDateDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'startDate': value['startDate'] == null ? undefined : ((value['startDate'] as any).toISOString()),
        'startVersion': value['startVersion'],
        'endDate': value['endDate'] == null ? undefined : ((value['endDate'] as any).toISOString()),
        'endVersion': value['endVersion'],
    };
}

